<template>
  <div class="recharge" id="orderList">
    <div class="recharge-title">
      我的钱包 /
      <span>提现申请</span>
    </div>
    <div class="withdraw-tips">微信/支付宝平台收取提现手续费0.6%</div>
    <div class="recharge-payment-mode">
      <div class="recharge-payment-mode-title">提现到：</div>
      <div class="disanfang">
        <div
          v-if="isShow('ALIPAY')"
          :class="{ selected: payMode[0].selected }"
          @click="payMethod('ALIPAY')"
        >
          <svg class="icon icona_xiadan_weixin" aria-hidden="true">
            <use xlink:href="#icona_xiadan_weixin" />
          </svg>
          <div>
            支付宝账户
            <span v-if="!!$store.state.userInfo.cashOutAccountAlipay">{{
              $store.state.userInfo.cashOutAccountAlipay
            }}</span>
          </div>
        </div>
        <div
          style="margin-left: 15px"
          v-if="isShow('WECHAT')"
          :class="{ selected: payMode[1].selected }"
          @click="payMethod('WECHAT')"
        >
          <svg class="icon icona_xiadan_zhifubao" aria-hidden="true">
            <use xlink:href="#icona_xiadan_zhifubao" />
          </svg>
          <div>
            微信账户
            <span v-if="!!$store.state.userInfo.cashOutAccountWechatNickname">{{
              $store.state.userInfo.cashOutAccountWechatNickname
            }}</span>
          </div>
        </div>
        <span
          @click="goSafety()"
          v-if="
            !$store.state.userInfo.cashOutAccountAlipay ||
            !$store.state.userInfo.cashOutAccountWechatNickname
          "
          class="binding"
          >去绑定 <i class="el-icon-arrow-right"></i
        ></span>
      </div>
      <div class="recharge-price">
        <div class="total-money">
          可提现金额
          <span>{{ balance.toString().split(".")[0] }}</span
          ><span v-if="balance.toString().indexOf('.') != -1">.</span>
          {{ balance.toString().split(".")[1] }} 元
        </div>
        <div class="recharge-money">提现金额：</div>
        <el-input
          class="default-input"
          oninput="value=value.replace(/[^0-9.]/g,'')"
          v-model="input"
          @input="rechargeMoney"
          placeholder="请输入提现金额"
        ></el-input>
        <span class="quanbu" @click="input = balance">全部提现</span>
        <div class="actual-arrival" v-if="input == ''">
          实际到账:
          <span>0.00</span>元
        </div>
        <div class="actual-arrival" v-else>
          实际到账:
          <span>
            {{ Math.floor(input * 0.994 * 100) / 100 }}
            <!-- {{Math.floor((input-input*0.006)*100)/100}} --> </span
          >元
        </div>
        <el-button
          :disabled="input == '' ? true : false"
          class="lijizhifu"
          @click="openPhonePicker()"
          >确认提现</el-button
        >
      </div>
    </div>
    <!-- 手机验证 -->
    <el-dialog
      title="提现身份验证"
      :visible.sync="verification"
      @close="onClose"
      width="30%"
      class="set-pass pass"
    >
      <div>
        <div class="steps">为了您的账号安全，请验证身份</div>
        <div class="phone">
          <span>手机号:</span>
          {{ phoneNum }}
        </div>
        <el-form ref="setPassword" label-width="100px" class="demo-ruleForm">
          <el-form-item prop="phoneCode">
            <el-input
              v-model="phoneCode"
              type="number"
              placeholder="请输入验证码"
              maxlength="6"
            >
              <span
                v-if="getYzm"
                slot="suffix"
                class="get_yzm"
                @click="yzmTimeMinuse()"
                >{{ yzmTtext }}</span
              >
              <span v-else slot="suffix">{{ yzmTime }}S后重发</span>
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="verification = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="phoneCode == '' ? true : false"
          :loading="loading"
          @click="applyForWithdrawal()"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 支付宝补全提现用户真实姓名 -->
    <el-dialog
      class="set-pass pass"
      @close="yzClose"
      title="未绑定支付宝真实姓名"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div>
        <div class="realname_label">
          1、支付宝提现需要绑定真实姓名，请输入账户对应的真实名
        </div>
        <div class="realname_label">
          2、如需更换账户，请到“个人中心-个人设置中”解绑
        </div>
        <div class="zfb_account">
          支付宝账号：{{
            $store.state.userInfo.cashOutAccountAlipay
          }}
        </div>
        <div class="realname_name">
          真实姓名<el-input
            v-model="$store.state.userInfo.cashOutAlipayRealName"
            placeholder="您的真实姓名"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindAlipay()">确 定</el-button>
      </span>
    </el-dialog>
    <Geet :isGeet="isgt" @geetPath="onGeetestValCodePath" @clickChange="onGeetChange"></Geet>
  </div>
</template>

<script>
import store from "@/store/";
import Geet from "./Geet.vue";
import { geetestValCodeMixin } from "../../mixins/geetestValCodeMixin";

export default {
  mixins: [geetestValCodeMixin],
  data() {
    return {
      getYzm: true,
      zhifubao: true,
      wechat: false,
      dialogVisible: false,
      payMode: [
        { selected: true, name: "ALIPAY" },
        { selected: false, name: "WECHAT" },
      ],
      input: "",
      payWay: "ALIPAY", // 体现方式，默认支付宝 提现方式，ALIPAY支付宝，WECHAT微信
      balance: "",
      phoneNum: "",
      phoneCode: "",
      verification: false,
      yzmTime: 60,
      yzmTtext: "发送验证码",
      auth_timetimer: "",
      loading: false,
      cashOutWay: [],
      realName: "",
    };
  },
  components: {
    Geet
  },
  // 接收注入的数据
  inject: ["reload"],
  mounted() {
    this.getBalance();
    // 获取可用支付方式
    this.$fetch(`/common/platform/get_pay_way`).then((res) => {
      if (res.code == 0) {
        this.cashOutWay = res.data.cashOutWay;
        // 设置默认支付方式
        this.payMethod(res.data.cashOutWay[0]);
      } else {
        this.$message(res.message);
      }
    });
  },

  methods: {
    onValCodeSent() {
      this.getYzm = false;
      this.yzmTime = 60;

      this.auth_timetimer = setInterval(() => {
        this.yzmTime--;
        if (this.yzmTime <= 0) {
          this.getYzm = true;
          clearInterval(this.auth_timetimer);
          this.yzmTtext = "重新发送";
        }
      }, 1000);
    },
    yzClose() {
      this.$store.state.userInfo.cashOutAlipayRealName = "";
    },
    bindAlipay() {
      this.$message.closeAll();
      if (!this.$store.state.userInfo.cashOutAlipayRealName) {
        return this.$message({
          message: "请先输入您的真实姓名",
          type: "warning",
        });
      }else{
        this.dialogVisible=false
        this.openPhonePicker()
      }
    },
    // 是否显示
    isShow(item) {
      if (this.cashOutWay.indexOf(item) != -1) {
        return true;
      } else {
        return false;
      }
    },
    // 支付方式
    payMethod(item) {
      for (let i of this.payMode) {
        i.selected = false;
        if (item == i.name) {
          i.selected = true;
        }
      }
      this.payWay = item;
    },
    // 获取余额
    getBalance() {
      var _this = this;
      this.$fetch(`/user/api/customer/balance`).then((res) => {
        if (res.code == 0) {
          _this.balance = res.data.balance;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 打开手机验证弹窗
    openPhonePicker() {
      this.$message.closeAll();
      // this.dialogVisible = true;
      if (!this.$store.state.userInfo.cashOutAccountAlipay) {
        this.$message({
          message: "请先绑定支付宝",
          type: "warning",
        });
      } else {
        if (!store.state.userInfo.cashOutAlipayRealName) {
          this.dialogVisible = true;
        }
        if (Number(this.input) >= 100) {
          var reg = /^(\d{3})\d{4}(\d{4})$/;
          this.phoneNum = this.$store.state.userPhone.replace(reg, "$1****$2");
          this.verification = true;
        } else {
          this.$message({
            message: "最低提现100元",
            type: "warning",
          });
        }
      }
    },
    // 输入的金额
    rechargeMoney(val) {
      if (val > this.balance) {
        this.input = this.balance;
      }
    },
    // 申请体现
    applyForWithdrawal() {
      this.loading = true;
      this.$post(
        `/order/api/withdraw?amount=${this.input}&payWay=${this.payWay}&code=${this.phoneCode}&realName=${this.$store.state.userInfo.cashOutAlipayRealName}`
      ).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.message,
            type: "success",
          });
          this.loading = false;
          setTimeout(() => {
            this.verification = false;
            this.$router.push({ path: "/user/wallet" });
          }, 500);
        } else {
          this.loading = false;
          this.$message(res.message);
        }
      });
    },
    //验证码倒计时
    yzmTimeMinuse() {
      this.requestValCodeV2(this.$store.state.userPhone, "withdraw_money");
    },
    // 验证码关闭
    onClose() {
      clearInterval(this.auth_timetimer);
      this.getYzm = true;
      this.yzmTime = 60;
    },
    // 去绑定
    goSafety() {
      this.$router.push({ path: "/user/safety" });
    },
  },
};
</script>
<style lang="scss">
.recharge-price {
  .default-input {
    width: auto;
  }
}
.recharge {
  .pass {
    .el-dialog__header {
      padding: 20px 45px 10px !important;
    }
    .el-dialog__title {
      font-weight: bold;
    }
    .el-dialog__body {
      padding: 5px 45px !important;
      position: relative;
      .icon {
        position: absolute;
        right: 45px;
        top: 15px;
        width: 19px;
        height: 19px;
        color: #c9cdd5;
        cursor: pointer;
      }
    }
    .el-dialog__footer {
      padding: 0px 45px 20px;
      // margin-top: 10px;
    }
  }

  .notarrival {
    display: flex;
    align-items: center;
  }
  .arrival {
    .two_label {
      .type_name {
        width: 69px;
      }
    }
  }
  .arrival-tishi {
    font-size: 12px;
    height: 12px;
    line-height: 1;
    color: #909399;
    margin-bottom: 24px;
  }
  .el-dialog {
    width: 459px !important;
  }
}
</style>
<style lang="scss" scoped>
.pass {
  /deep/.el-dialog__footer {
    padding-top: 20px;
  }
}
.realname_label {
  font-size: 12px;
  color: #333;
  margin-top: 8px;
  &:first-child {
    margin-top: 0;
  }
}
.realname_name {
  margin-top: 12px;
  &/deep/.el-input {
    input {
      padding: 0;
      height: 40px;
    }
  }
}
.zfb_account {
  margin-top: 12px;
  font-weight: bold;
}
.recharge {
  height: 509px;
  background: #ffffff;
  padding: 24px 20px 40px 20px;
  .recharge-title {
    color: #5e6066;
    font-size: 18px;
    height: 18px;
    line-height: 1;
    span {
      color: #909399;
    }
  }
  .withdraw-tips {
    color: #909399;
    font-size: 12px;
    height: 12px;
    line-height: 1;
    margin-top: 12px;
  }
  .recharge-payment-mode {
    // width: 450px;
    margin: 0 auto;
    margin-top: 28px;
    margin-left: 233px;
    .recharge-payment-mode-title {
      color: #5e6066;
      font-size: 14px;
      height: 14px;
      line-height: 1;
    }
    .disanfang {
      display: flex;
      // justify-content: space-between;
      margin-top: 16px;
      position: relative;
      .binding {
        position: absolute;
        bottom: -20px;
        cursor: pointer;
        &:hover {
          color: #3455d3;
        }
      }
      & > div {
        max-width: 250px;
        height: 100px;
        background: rgba(249, 250, 250, 1);
        border-radius: 2px;
        border: 1px solid rgba(206, 212, 219, 1);
        font-size: 16px;
        padding: 22px 20px;
        color: #5e6066;
        display: flex;
        align-items: center;
        cursor: pointer;
        padding-right: 25px;
        .icon {
          width: 56px;
          height: 56px;
          color: #b4b7bc;
          margin-right: 8px;
        }
        & > div {
          max-width: 143px;
          display: flex;
          flex-direction: column;
          align-items: center;
          span {
            font-size: 12px;
          }
        }
        &:last-child {
          margin-left: 12px;
        }
      }
      .selected {
        background: rgba(243, 245, 253, 1);
        border: 1px solid rgba(52, 85, 211, 1);
        color: #2f3133;
        .icon {
          color: #3455d3;
        }
      }
    }
    .recharge-price {
      margin-top: 42px;
      .lijizhifu {
        width: 190px;
        height: 30px;
        background: rgba(52, 85, 211, 1);
        border-radius: 2px;
        border-color: #3455d3;
        color: #ffffff;
        font-size: 14px;
        padding: 0;
        margin-top: 30px;
      }
      .total-money {
        font-size: 14px;
        color: #5e6066;
        height: 24px;
        line-height: 1;
        span {
          font-size: 24px;
        }
      }
      .recharge-money {
        color: #5e6066;
        font-size: 14px;
        height: 14px;
        line-height: 1;
        margin-top: 24px;
        margin-bottom: 16px;
      }
      .quanbu {
        color: #3455d3;
        font-size: 12px;
        margin-left: 12px;
        cursor: pointer;
      }
      .actual-arrival {
        height: 24px;
        font-size: 14px;
        color: #5e6066;
        line-height: 1;
        margin-top: 24px;
        span {
          font-size: 24px;
          color: #f75658;
        }
      }
    }
  }
  .set-pass {
    .steps {
      color: #909399;
      font-size: 12px;
    }
    .phone {
      color: #2f3133;
      font-size: 14px;
      height: 14px;
      line-height: 1;
      margin-top: 30px;
      margin-bottom: 10px;
      span {
        color: #5e6066;
        margin-right: 6px;
      }
    }
    & /deep/ .get_yzm {
      background: transparent !important;
    }
    & /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
    .el-button--default {
      color: #bec0c6;
      border-color: #bec0c6;
      width: 60px;
      height: 28px;
      padding: 0 !important;
      border-radius: 2px;
    }
    .el-button--primary {
      background: #3455d3;
      color: #fff;
      border-color: #3455d3;
      width: 60px;
      height: 28px;
      padding: 0 !important;
      border-radius: 2px;
    }
  }
}
</style>
